import { useMemo, useState } from "react";

import { useUserRole } from "components/Sidebar/hooks/useUserRole";
import { getConsultationTabOptions } from "features/consultations/utils/consultationTabs";
import { usePracticeSettings } from "features/practice/hooks/usePracticeSettings";

export const useConsultationTabs = ({
  isReadOnly = false,
  hasEmail = false,
} = {}) => {
  const [tab, setTab] = useState("add-note");
  const { data: practiceSettings } = usePracticeSettings();
  const { tenantType } = useUserRole();

  const tabOptions = useMemo(
    () =>
      getConsultationTabOptions({
        isReadOnly,
        hasEmail,
        practiceSettings,
        tenantType,
      }),
    [isReadOnly, hasEmail, practiceSettings, tenantType]
  );

  return { tab, setTab, tabOptions };
};
